import React, { Component, Fragment } from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";
import "./groupBarWithoutAxis.style.scss";

class GroupBarWithoutAxis extends Component {
  componentDidMount() {
    const { w, h, id, data } = this.props;

    if (data && data.length > 0) {
      this.drawChart({
        w: w,
        h: h,
        id,
        data,
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    const { w, h, id, data } = nextProps;

    if (
      (data &&
        data.length > 0 &&
        JSON.stringify(data) !== JSON.stringify(this.props.data)) ||
      (data && data.length > 0 && this.props.w !== w)
    ) {
      this.drawChart({
        w: w,
        h: h,
        id,
        data,
      });
    }
  }

  drawChart = ({ w, h, id, data }) => {
    if (!data && data.length === 0) return;
    d3.select(`#${id}`).selectAll("svg").remove();
    const margin = { top: 20, right: 20, bottom: 10, left: 40 },
      width = w - margin.left - margin.right,
      height = h - margin.top - margin.bottom;

    const x0 = d3.scale.ordinal().rangeRoundBands([0, width], 0.1);

    var x1 = d3.scale.ordinal();

    var y = d3.scale.linear().range([height, 0]);

    var xAxis = d3.svg.axis().scale(x0).tickSize(0).orient("bottom");

    // var yAxis = d3.svg.axis().scale(y).orient("left");

    var color = d3.scale.ordinal().range([" #00B0F0", "#4472C4"]);

    var svg = d3
      .select(`#${id}`)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var categoriesNames = data.map(function (d) {
      return d.categorie;
    });
    var rateNames = data[0].values.map(function (d) {
      return d.group;
    });

    x0.domain(categoriesNames);
    x1.domain(rateNames).rangeRoundBands([0, x0.rangeBand()]);
    y.domain([
      0,
      d3.max(data, function (categorie) {
        return d3.max(categorie.values, function (d) {
          return d.value;
        });
      }),
    ]);

    svg
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis);

    // svg
    //   .append("g")
    //   .attr("class", "y axis")
    //   .style("opacity", "0")
    //   .call(yAxis)
    //   .append("text")
    //   .attr("transform", "rotate(-90)")
    //   .attr("y", 6)
    //   .attr("dy", ".71em")
    //   .style("text-anchor", "end")
    //   .style("font-weight", "bold")
    //   .text("Value");

    var slice = svg
      .selectAll(".slice")
      .data(data)
      .enter()
      .append("g")
      .attr("class", "g")
      .attr("transform", function (d) {
        return "translate(" + x0(d.categorie) + ",0)";
      });

    slice
      .selectAll("rect")
      .data(function (d) {
        return d.values;
      })
      .enter()
      .append("rect")
      //   .attr("width", x1.rangeBand() / 1.2)
      .attr("width", 15)
      .attr("x", function (d, i, j) {
        if (i === 0) {
          return x1(d.group) + 12;
        } else {
          return x1(d.group) / 2 + 22;
        }
        // if (i == 0) {
        //   return 15;
        // } else {
        //   return 35;
        // }
      })
      .style("fill", function (d) {
        return color(d.group);
      })
      .attr("y", function (d) {
        return y(0);
      })
      .attr("height", function (d) {
        return height - y(0);
      })
      .append("title")
      .text((d) => {
        return `${d.group.toUpperCase()} : ${d.value.toFixed(2)}%`;
      });
    // .on("mouseover", function (d) {
    //   d3.select(this).style("fill", d3.rgb(color(d.group)).darker(2));
    // })
    // .on("mouseout", function (d) {
    //   d3.select(this).style("fill", color(d.group));
    // });

    slice
      .selectAll("rect")
      .transition()
      .delay(function (d) {
        return Math.random() * 1000;
      })
      .duration(1000)
      .attr("y", function (d) {
        return y(d.value);
      })
      .attr("height", function (d) {
        let v = height - y(d.value);
        if (v < 0) {
          return 0;
        } else {
          return v;
        }
      });

    slice
      .selectAll("text")
      .data(function (d) {
        return d.values;
      })
      .enter()
      .append("text")
      .attr("class", "barstext")
      .attr("x", function (d, i) {
        let val = i === 0 ? 10 : 4;
        return x1(d.group) + val;
      })
      .attr("y", function (d) {
        return y(d.value) - 5;
      })
      .text(function (d) {
        return d.value.toFixed(2) + "%";
      });
    // .attr("transform", function (d, i) {
    //   let x;
    //   if (i == 0) {
    //     x = 15 + 7.5 + 7;
    //   } else {
    //     x = 35 + 7.5;
    //   }
    //   return "translate(" + x + ",0) rotate(-90)";
    // });
  };
  render() {
    const { id, data, label } = this.props;
    return (
      <Fragment>
        {data && data.length > 0 ? (
          <Fragment>
            <div id={id} className="groupBarWithoutAxis" />
            <div
              className="groupBarWithoutAxis__label"
              style={{ fontSize: label && label.length > 65 ? "8px" : "" }}
            >
              <span />
              Benchmark : {label}
            </div>
          </Fragment>
        ) : null}
        {data && data.length === 0 ? (
          <div className="groupBarWithoutAxis_no_data">No Data</div>
        ) : null}
      </Fragment>
    );
  }
}

GroupBarWithoutAxis.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      categorie: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          group: PropTypes.string.isRequired,
          value: PropTypes.number.isRequired,
        })
      ),
    })
  ),
};
export default GroupBarWithoutAxis;



// WEBPACK FOOTER //
// ./src/components/d3Components/groupBarWithoutAxis/groupBarWithoutAxis.jsx